import { Dispatch } from "react";
import { TZoomActions } from '../actions/zoomActions';

export const zoomIn = (data: { x: number, y: number, pivotX: number, pivotY: number, scale: number }) => {
    return async (dispatch: Dispatch<TZoomActions>) => {
        dispatch({
            type: "ZOOM_IN",
            payload: data,
        });
    };
}

export const scrollInZoomInMode = (data: { pivotX: number, pivotY: number}) => {
    return async (dispatch: Dispatch<TZoomActions>) => {
        dispatch({
            type: "SCROLL_IN_ZOOM",
            payload: data,
        });
    };
}
